import qs from 'qs';
import { paths as entPaths } from 'spark-views/enterprise/enterpriseRoutes';
import { paths as gapPacketPaths } from 'spark-views/gapPacketManagement/gapPacketRoutes';
import { paths as ibAdminPaths, navigation as ibAdminNav } from 'spark-views/InvestigatorBrochure/ibAdmin/ibAdminRoutes';
import { navigation as ibRecipientNav, paths as ibRecipientPaths } from 'spark-views/InvestigatorBrochure/ibNotifications/ibNotificationsRoutes';
import { paths as adminPaths, navigation as adminNav } from 'spark-views/safetyLetter/admin/adminRoutes';
import {
	paths as notificationPaths,
	navigation as notificationNav
} from 'spark-views/safetyLetter/notifications/notificationRoutes';
import { USER_GUIDES_BASE_PATH } from 'spark-views/userGuides/UserGuidesRoute';

// SAF-20237: Define redirects for each role type (Role Assignment - Switch Roles and its Precedence - PSR-4763)
// Separate redirects for Safety, GP, and IB recipients ensure correct landing pages based on module access
// SAF-20491: Split supportUsers into module-specific redirects so each support role lands on its correct module
const redirects = {
	enterpriseAdmin: () => entPaths.enterpriseList,
	managementUsers: (id) => (id ? adminNav.details.root(id) : adminPaths.notifications),
	safetySupportUsers: (id) => (id ? adminNav.details.root(id) : adminPaths.notifications),
	ibSupportUsers: (id) => (id ? ibAdminNav.details.root(id) : ibAdminPaths.notifications),
	gapPacketSupportUsers: () => gapPacketPaths.gapPacketList,
	safetyRecipientUsers: (id) => (id ? notificationNav.details(id) : notificationPaths.notifications),
	gapPacketAdminUsers: () => gapPacketPaths.gapPacketList,
	gapPacketRecipientUsers: () => gapPacketPaths.acknowledge,
	iBAdminUsers: (id) => (id ? ibAdminNav.details.root(id) : ibAdminPaths.notifications), //SAF-17154 - added redirect path for IB_Admin Users
	ibRecipientUsers: (id) => (id ? ibRecipientNav.details(id) : ibRecipientPaths.notifications)
};

// SAF-20237: Route users based on module-specific recipient flags (Role Assignment - Switch Roles and its Precedence - PSR-4763)
// SAF-20491: Route each support role to its own module instead of defaulting all to Safety
// Priority: Enterprise Admin > Safety Mgmt > Safety Support > GP Support > GP Admin > IB Support > IB Mgmt > Recipients
const getUserRedirect = ({ enterpriseAdmin, managementUser, isSafetySupport, isIBSupport, isGapPacketSupport, isGapPacketAdmin, isIBManagementUser, isSafetyRecipient, isGapPacketRecipient, isIBRecipient }) =>
	enterpriseAdmin
		? redirects.enterpriseAdmin
		: managementUser ? redirects.managementUsers
		: isSafetySupport ? redirects.safetySupportUsers
		: isGapPacketAdmin ? redirects.gapPacketAdminUsers
		: isGapPacketSupport ? redirects.gapPacketSupportUsers
		: isIBManagementUser ? redirects.iBAdminUsers
		: isIBSupport ? redirects.ibSupportUsers
		: isSafetyRecipient ? redirects.safetyRecipientUsers
		: isGapPacketRecipient ? redirects.gapPacketRecipientUsers
		: isIBRecipient ? redirects.ibRecipientUsers
		: null; // No valid role - will route to nosndata page

const getQueryParams = (search) => qs.parse(search, { ignoreQueryPrefix: true }) || {};

const getInitialRedirect = (search = '', userType, pathname = '') => {
	const isUserGuidePage = pathname.includes('/userGuides');
	//SAF-18432-Safety - User Guide Integration- to open  User Guides page on new tab and to avaoid redirecting to home page.
	if (isUserGuidePage) return USER_GUIDES_BASE_PATH;

	const queryParams = getQueryParams(search);
	const redirect = getUserRedirect(userType);
	// If no valid role redirect found, return null to trigger nosndata page
	return redirect ? redirect(queryParams.id, queryParams.category) : null;
};

export default getInitialRedirect;
